import { Field as FieldT, FieldOptionBase } from 'api/tasks';
import {
  MultiSelectField,
  SingleSelectField,
} from '../components/organisms/tasks/fields';
import { byPosition } from './comparators/by-position';

const constructOptionByValue = <T extends FieldOptionBase = FieldOptionBase>(
  oldMap: Record<number, T>,
  option: T,
  idx: number,
  array: T[],
) => {
  const activeOptionByValue = (value) =>
    array.find((o) => o.value === value && o.active);
  const inactiveOptionByValue = (value) => array.find((o) => o.value === value);

  return {
    ...oldMap,
    [option.value]:
      activeOptionByValue(option.value) || inactiveOptionByValue(option.value)!,
  };
};

export const FieldHelper = (
  field: FieldT | SingleSelectField | MultiSelectField,
) => {
  const { metaData } = field;
  const activeOptions = (() => {
    return (metaData?.options ?? [])
      .filter(({ active }) => {
        return active;
      })
      .sort(byPosition);
  })();

  const allOptions = (() => {
    const options = metaData?.options;

    const byValue =
      options
        ?.slice()
        ?.reduce<Record<number, typeof options[0]>>(
          constructOptionByValue,
          {} as any,
        ) ?? {};

    const nonDuplicateOptions = Object.values(byValue) ?? [];

    return nonDuplicateOptions.sort(byPosition);
  })();

  const originalOptions = (() => {
    return metaData?.options;
  })();

  return {
    options: {
      activeOptions,
      allOptions,
      originalOptions,
    },
  };
};
